import { InputButton } from '@infotech-soe/erp-ui-kit';
import React, { memo } from 'react';

import {
  DateFormControlViewModel,
  NumericInputFormControlViewModel,
  TextInputFormControlViewModel,
} from '../../../services/form/view-model/FormControlViewModel';

interface Props {
  control:
    | DateFormControlViewModel
    | NumericInputFormControlViewModel
    | TextInputFormControlViewModel;
  updater: () => void;
}

const UpdaterButton = ({ control, updater }: Props): React.JSX.Element => (
  <InputButton
    disabled={
      control.disabled || (control.readonly && !control.enableButtonOnReadOnly)
    }
    icon="refresh"
    onClick={updater}
  />
);

export default memo(UpdaterButton);
